import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import Row from 'components/common/Row';
import OptionButton from 'containers/ProductRegist/components/common/OptionButton';
import CurriculumForm from 'containers/ProductRegist/components/InformationRegist/components/CurriculumForm';
import { useCurriculumHooks } from 'containers/ProductRegist/components/InformationRegist/hooks/useCurriculumHooks';
import { ProductParamInput } from 'containers/ProductRegist/hooks/types';
import { CurriculumStyle, Product, ProductState } from 'types/api';
import Column from 'components/common/Column';
import Text from 'components/common/Text';
import { ModifyValue } from 'containers/ProductDetail/hooks/useProductDetaillHooks';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import SaveButton from '../SaveButton';
import HackleManager from 'utils/hackle';
import CalloutContainer from 'containers/ProductRegist/components/InformationRegist/components/CalloutContainer';
import ModalHeader from './ModalHeader';
import TitleContainer from 'containers/ProductRegist/components/TitleContainer';
interface ScheduleModifyFormIprops {
  isMobile: boolean;
  productParamInput: ProductParamInput;
  productInfo: Product;
  modifyValue: ModifyValue;
  setModifyValue: Dispatch<SetStateAction<ModifyValue>>;
  handleOnChangeProductParamInput: (key: string, value: any) => void;
}

const ScheduleModifyForm: React.FC<ScheduleModifyFormIprops> = props => {
  const {
    isMobile,
    productParamInput,
    productInfo,
    modifyValue,
    setModifyValue,
    handleOnChangeProductParamInput,
  } = props;

  const [copyProductParamInput, setCopyProductParamInput] =
    useState<ProductParamInput>(productParamInput);

  const fripInfo = copyProductParamInput.frip;

  const handleOnChangeCopyProductParamInput = (key: string, value: any) => {
    setCopyProductParamInput({ ...copyProductParamInput, [key]: value });
  };

  const {
    handleResetCurriculum,
    handleInitCurriculum,
    handleAddCurriculumSections,
    handleAddCurriculumItems,
    handleDeleteCurriculumItems,
    handleRemoveCurriculumItems,
  } = useCurriculumHooks(
    copyProductParamInput,
    handleOnChangeCopyProductParamInput,
  );

  const scheduleValidation = (): boolean => {
    switch (fripInfo.curriculum.style) {
      case CurriculumStyle.DURATION: {
        return fripInfo.curriculum.sections.every(
          item =>
            ((item.isOpenEtc && item.etc !== '') || !item.isOpenEtc) &&
            item.title !== '' &&
            item.items.every(scheduleItem => scheduleItem.content !== ''),
        );
      }
      case CurriculumStyle.TIMETABLE: {
        return fripInfo.curriculum.sections.every(
          item =>
            ((item.isOpenEtc && item.etc !== '') || !item.isOpenEtc) &&
            item.title !== '' &&
            item.items.every(scheduleItem => scheduleItem.content !== ''),
        );
      }
      case CurriculumStyle.LEGACY: {
        return fripInfo.curriculum.sections.every(
          item =>
            ((item.isOpenEtc && item.etc !== '') || !item.isOpenEtc) &&
            item.title !== '' &&
            item.items.every(
              scheduleItem =>
                scheduleItem.textTime !== '' && scheduleItem.content !== '',
            ),
        );
      }
      default:
        return false;
    }
  };

  const isAbled = !isEmpty(copyProductParamInput.frip.curriculum.sections)
    ? scheduleValidation() &&
      productParamInput.frip.curriculum.sections !==
        copyProductParamInput.frip.curriculum.sections
    : productParamInput.frip.curriculum.sections !==
      copyProductParamInput.frip.curriculum.sections;

  const handleRegistSchedule = () => {
    handleOnChangeProductParamInput('frip', {
      ...productParamInput.frip,
      curriculum: copyProductParamInput.frip.curriculum,
    });
  };

  const handleResetSchedule = () => {
    setCopyProductParamInput(productParamInput);
  };

  useEffect(() => {
    HackleManager.logProductModifyCurriculumView(
      Number(productInfo.id),
      productInfo.title,
    );
  }, []);

  const renderScheduleSelectForm = (): JSX.Element => {
    return (
      <React.Fragment>
        <Row gap="8px" style={{ width: '100%' }}>
          <OptionButton
            text="시간표"
            isSelected={fripInfo.curriculum.style === CurriculumStyle.DURATION}
            onClick={() => {
              handleResetCurriculum(CurriculumStyle.DURATION);
            }}
          />
          <OptionButton
            text="구간표"
            isSelected={fripInfo.curriculum.style === CurriculumStyle.TIMETABLE}
            onClick={() => {
              handleResetCurriculum(CurriculumStyle.TIMETABLE);
            }}
          />
          <OptionButton
            text="직접 입력"
            isSelected={fripInfo.curriculum.style === CurriculumStyle.LEGACY}
            onClick={() => {
              handleResetCurriculum(CurriculumStyle.LEGACY);
            }}
          />
        </Row>
        {fripInfo.curriculum.style !== CurriculumStyle.NONE && (
          <CalloutContainer curriculumStyle={fripInfo.curriculum.style} />
        )}
      </React.Fragment>
    );
  };

  const renderCurriculumForm = (): JSX.Element => {
    return (
      fripInfo.curriculum.style !== CurriculumStyle.NONE && (
        <CurriculumForm
          productParamInput={copyProductParamInput}
          handleAddCurriculumItems={handleAddCurriculumItems}
          handleAddCurriculumSections={handleAddCurriculumSections}
          handleDeleteCurriculumItems={handleDeleteCurriculumItems}
          handleRemoveCurriculumItems={handleRemoveCurriculumItems}
          handleOnChangeProductParamInput={handleOnChangeCopyProductParamInput}
          handleResetCurriculum={handleResetCurriculum}
        />
      )
    );
  };

  const renderContents = (): JSX.Element => {
    if (isMobile) {
      return (
        <ModalContainer
          isMobile={isMobile}
          isAbled={productInfo.status !== ProductState.CLOSED && isAbled}
          onCloseText=" "
          onAcceptText="적용"
          onClose={() => {
            setModifyValue({ ...modifyValue, modifyStatus: '' });
          }}
          onClick={() => {
            if (isAbled) {
              HackleManager.logProductModifyItemSaveComplete(
                Number(productInfo.id),
                productInfo.title,
                '스케줄',
              );
              handleRegistSchedule();

              setModifyValue({
                ...modifyValue,
                isModify: true,
                modifyStatus: '',
              });
            }
          }}
        >
          <Column style={{ position: 'relative' }}>
            <ModalHeader
              title="스케줄 수정하기"
              modifyValue={modifyValue}
              setModifyValue={setModifyValue}
              style={{ padding: '24px 20px' }}
            />
            <Column gap="24px" style={{ padding: '0 20px' }}>
              {renderScheduleSelectForm()}
              {renderCurriculumForm()}
            </Column>
          </Column>
        </ModalContainer>
      );
    }

    return (
      <Column style={{ padding: '0 40px' }}>
        <TitleContainer title="스케줄 수정하기" isMobile={isMobile} />
        <Column gap="24px">
          {renderScheduleSelectForm()}
          {renderCurriculumForm()}
          {productInfo.status !== ProductState.CLOSED && (
            <SaveButton
              isAbled={isAbled}
              modifyValue={modifyValue}
              setModifyValue={setModifyValue}
              handleResetItem={handleResetSchedule}
              handleRegistItem={() => {
                HackleManager.logProductModifyItemSaveComplete(
                  Number(productInfo.id),
                  productInfo.title,
                  '스케줄',
                );
                handleRegistSchedule();
              }}
            />
          )}
        </Column>
      </Column>
    );
  };

  return renderContents();
};

export default ScheduleModifyForm;
